import AlertBanner from "@/pages/home/components/AlertBanner";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

import OverviewSection from "./components/OverviewSection";
import ScheduleTables from "./components/ScheduleTables";
import InfoCards from "./components/InfoCards";

export default function AirportShuttle() {
  return (
    <div className="min-h-screen flex flex-col">
      <AlertBanner />
      <Header />
      <main className="flex-1">
       
        <OverviewSection />
        <ScheduleTables />
        <InfoCards />
      </main>
      <Footer />
    </div>
  );
}